import React, { useState } from 'react';

import { Box, Badge, Tooltip, IconButton } from '@mui/material';

import { useTranslate } from 'src/locales';

import { Iconify } from '../iconify';
import FilterPopover from '../filterPopover/advanceFilterPopover';

export default function TableAdvanceFilter({
  advanceFilterFields,
  setAdvanceFilter,
  advanceFilters,
  resetPagination,
}: any) {
  const { t } = useTranslate('translation');

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);
  const showBadge =
    Array.isArray(advanceFilters) &&
    advanceFilters.length > 0 &&
    advanceFilters.some((f) => f.value?.trim() !== '');
  return (
    <>
      <Box>
        <Tooltip title={t('ADVANCE_FILTER')}>
          <Badge
            color="error"
            variant="dot"
            overlap="circular"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            invisible={!showBadge}
          >
            <IconButton size="small" sx={{ mx: 2 }} onClick={(event) => handleClick(event)}>
              <Iconify icon="mdi:filter-multiple" />
            </IconButton>
          </Badge>
        </Tooltip>
      </Box>
      <FilterPopover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        advanceFilterFields={advanceFilterFields}
        setAdvanceFilter={setAdvanceFilter}
        advanceFilters={advanceFilters}
        resetPagination={resetPagination}
      />
    </>
  );
}
